import { Updater, useLocalStorageState, useSelector } from '@topwrite/common';

export default function useLocalStorageStateWithBook<T>(key: string, initialValue: T): [T, Updater<T>] {

    const { id } = useSelector('book');

    key = `editor.${id}.${key}`;

    return useLocalStorageState(key, initialValue);
}
